import { FirebaseStorage } from 'services/firebase';
import { FireBaseCollections } from 'utils/firebase';

export const getWalletBankScreenSeenCount = async (teamId: number | string): Promise<number> => {
  const rawCount = await FirebaseStorage.getTeamsCollectionFieldValue({
    teamId: teamId.toString(),
    collectionFieldName: FireBaseCollections.Teams.fields.legalReacceptanceWalletBankScreenShownCount
  });
  return typeof rawCount === 'number' && !Number.isNaN(rawCount) ? rawCount : 0;
};
